import Footer from "@/components/shared/Footer";

const SolutionsPage = () => {
  const solutions = [
    { 
      title: 'Personal Injury Firms', 
      desc: 'Settlement range modeling, insurance behavior analysis, and medical documentation support.',
      metrics: ['45% higher settlements', '60% faster case prep', '3x documentation efficiency']
    },
    { 
      title: 'Commercial Litigation', 
      desc: 'Contract analysis, corporate pattern detection, and exposure modeling.',
      metrics: ['70% research reduction', 'Real-time opponent tracking', 'Automated response drafting']
    },
    { 
      title: 'Defense Practices', 
      desc: 'Risk assessment, plaintiff pattern analysis, and strategic positioning.',
      metrics: ['Early case evaluation', 'Settlement optimization', 'Exposure reduction']
    },
    { 
      title: 'Family Law', 
      desc: 'Asset analysis, custody pattern modeling, and judge tendency profiling.',
      metrics: ['Outcome prediction', 'Settlement guidance', 'Documentation support']
    }
  ];

  return (
    <main className="min-h-screen" style={{ background: '#F8FAFC' }}>
      <div className="container-shell py-16">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2.5 px-3.5 py-2.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-4"
            style={{ background: '#fff', border: '1px solid #D9E4F2', color: '#416588' }}>
            <span className="w-2 h-2 rounded-full" style={{ background: 'linear-gradient(135deg,#1D4ED8,#3B82F6,#14B8A6)' }}></span>
            Solutions
          </div>
          <h1 className="text-4xl lg:text-5xl font-bold mb-4" style={{ color: '#1E293B' }}>Built for Your Practice Area</h1>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: '#475569' }}>
            Intelligence tailored to your specific practice requirements and case types.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-6">
          {solutions.map(({ title, desc, metrics }) => (
            <div key={title} className="rounded-3xl p-8" style={{ background: '#fff', border: '1px solid #D9E4F2', boxShadow: '0 12px 30px rgba(15,23,42,.08)' }}>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#1E293B' }}>{title}</h3>
              <p className="mb-4" style={{ color: '#475569' }}>{desc}</p>
              <div className="flex flex-wrap gap-2">
                {metrics.map((m) => (
                  <span key={m} className="px-3 py-1.5 rounded-full text-xs font-semibold" style={{ background: '#dbeafe', color: '#1D4ED8' }}>
                    {m}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </main>
  );
};

export default SolutionsPage;
